import { useMemo } from "react";
import { compact } from "lodash";
import { usePunditUserContext } from "@circle-react/contexts";
import { hasRevenueCatPaymentProcessor } from "@circle-react/helpers/paymentProcessorHelpers";
import { possibleColumnsToRender } from "../constants";

export const useDefaultColumnsToRender = () => {
  const { currentCommunity } = usePunditUserContext();

  const paymentProcessors = currentCommunity?.payment_processors;

  const defaultColumnsToRender = useMemo(
    () =>
      compact([
        possibleColumnsToRender.customer,
        possibleColumnsToRender.status,
        possibleColumnsToRender.paywall,
        hasRevenueCatPaymentProcessor(paymentProcessors)
          ? possibleColumnsToRender.platform
          : null,
        possibleColumnsToRender.chargesQuantity,
        possibleColumnsToRender.term,
        possibleColumnsToRender.startDate,
        possibleColumnsToRender.renewalDate,
        possibleColumnsToRender.actionMenu,
      ]),
    [paymentProcessors],
  );

  return {
    defaultColumnsToRender,
  };
};
